import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { AdminRoute } from "@/routes/AdminRoute";
import { AdminPage } from "@/pages/AdminPage";
import { AdminLoginPage } from "@/pages/AdminLoginPage";
import { ADMIN_BASE_PATH, ADMIN_LOGIN_PATH } from "@/components/admin/adminConstants";
import { LandingPage } from "@/pages/LandingPage";
import { InviteLandingPage } from "@/pages/InviteLandingPage";
import { AppLinkLandingPage } from "@/pages/AppLinkLandingPage";
import { AboutPage } from "@/pages/legal/AboutPage";
import { AdsPage } from "@/pages/legal/AdsPage";
import { ChildSafetyPage } from "@/pages/legal/ChildSafetyPage";
import { ContactPage } from "@/pages/legal/ContactPage";
import { CookiesPage } from "@/pages/legal/CookiesPage";
import { CopyrightPage } from "@/pages/legal/CopyrightPage";
import { DataDeletionPage } from "@/pages/legal/DataDeletionPage";
import { DownloadPage } from "@/pages/legal/DownloadPage";
import { FaqPage } from "@/pages/legal/FaqPage";
import { GuidelinesPage } from "@/pages/legal/GuidelinesPage";
import { LegalHubPage } from "@/pages/legal/LegalHubPage";
import { PaymentsPage } from "@/pages/legal/PaymentsPage";
import { PressPage } from "@/pages/legal/PressPage";
import { PrivacyPage } from "@/pages/legal/PrivacyPage";
import { RefundCancellationPage } from "@/pages/legal/RefundCancellationPage";
import { TermsPage } from "@/pages/legal/TermsPage";

/**
 * Marketing / landing site only. The social product runs on Android.
 * App routes (login, feed, chat, etc.) are intentionally not served here.
 */
export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route index element={<LandingPage />} />
          <Route path="/invite/:userId" element={<InviteLandingPage />} />
          <Route path="/post/:id" element={<AppLinkLandingPage kind="post" />} />
          <Route path="/user/:id" element={<AppLinkLandingPage kind="user" />} />
          <Route path="/parallel/:id" element={<AppLinkLandingPage kind="parallel" />} />
          <Route path="/chat/:id" element={<AppLinkLandingPage kind="chat" />} />
          <Route
            path="/notifications"
            element={<AppLinkLandingPage kind="notifications" />}
          />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/TermsandConditions" element={<TermsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/ContactUs" element={<ContactPage />} />
          <Route path="/data-deletion" element={<DataDeletionPage />} />
          <Route path="/guidelines" element={<GuidelinesPage />} />
          <Route path="/child-safety" element={<ChildSafetyPage />} />
          <Route path="/copyright" element={<CopyrightPage />} />
          <Route path="/payments" element={<PaymentsPage />} />
          <Route path="/RefundandCancellation" element={<RefundCancellationPage />} />
          <Route path="/ads" element={<AdsPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/legal" element={<LegalHubPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/press" element={<PressPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
          {/* Admin panel — obscure, unlinked path; excluded from robots + nav. */}
          <Route
            path={ADMIN_LOGIN_PATH}
            element={
              <AuthProvider>
                <AdminLoginPage />
              </AuthProvider>
            }
          />
          <Route
            path={ADMIN_BASE_PATH}
            element={
              <AuthProvider>
                <AdminRoute>
                  <AdminPage />
                </AdminRoute>
              </AuthProvider>
            }
          />
          {/* Legacy app URLs → home (no web client) */}
          <Route path="/login" element={<Navigate to="/download" replace />} />
          <Route path="/signup" element={<Navigate to="/download" replace />} />
          <Route path="/admin/login" element={<Navigate to="/" replace />} />
          <Route path="/admin" element={<Navigate to="/" replace />} />
          <Route path="/forgot-password" element={<Navigate to="/download" replace />} />
          <Route path="/reset-password" element={<Navigate to="/download" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
